import {
  CUSTOMER_PAST_PURCHASES_LIST_REQUEST,
  CUSTOMER_PAST_PURCHASES_LIST_SUCCESS,
  CUSTOMER_PAST_PURCHASES_LIST_FAILURE
} from './constants';

const INITIAL_STATE = {
  list: null,
  isFetching: false,
  error: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CUSTOMER_PAST_PURCHASES_LIST_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case CUSTOMER_PAST_PURCHASES_LIST_SUCCESS: {
      const arr = Array.isArray(action.payload?.data)
        ? action.payload.data
        : [];
      return {
        ...state,
        isFetching: false,
        list: arr
      };
    }
    case CUSTOMER_PAST_PURCHASES_LIST_FAILURE:
      return {
        ...state,
        isFetching: false,
        list: [],
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
